module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZD0iTTIwLjU4NiwzOS40MTRDMjAuOTc3LDM5LjgwNSwyMS40ODgsNDAsMjIsNDBzMS4wMjMtMC4xOTUsMS40MTQtMC41ODZjMC43ODEtMC43ODEsMC43ODEtMi4wNDcsMC0yLjgyOEwxMi44MjgsMjZINDAgYzEuMTA0LDAsMi0wLjg5NiwyLTJzLTAuODk2LTItMi0ySDEyLjgyOGwxMC41ODYtMTAuNTg2YzAuNzgxLTAuNzgxLDAuNzgxLTIuMDQ3LDAtMi44MjhjLTAuNzgxLTAuNzgxLTIuMDQ3LTAuNzgxLTIuODI4LDBsLTE0LDE0IGMtMC43ODEsMC43ODEtMC43ODEsMi4wNDcsMCwyLjgyOEwyMC41ODYsMzkuNDE0eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow-left.svg
// module id = Cbmn
// module chunks = 46